import { createAction, props } from '@ngrx/store';
import { SkillsUsage } from '../skills/models/skills-usage.model';
import { Skill } from '../skills/models/skills.model';
import { AdminSkillApiError } from './admin-skills.errors';

export const AdminLoadSkillsAction = createAction('[Admin Skill Effect] Load Skills');

export const AdminSkillsLoadedAction = createAction(
  '[Admin Skill Effect] Skills Loaded',
  props<{ skills: Skill[] }>(),
);

export const AdminCreateSkillAction = createAction(
  '[Admin Skill Effect] Create Skill',
  props<{ values: Record<string, unknown> }>(),
);

export const AdminUpdateSkillAction = createAction(
  '[Admin Skill Effect] Update Skill',
  props<{ values: Record<string, unknown>; id: string }>(),
);

export const AdminDeleteSkillAction = createAction(
  '[Admin Skill Effect] Delete Skill',
  props<{ id: string }>(),
);

export const AdminDeleteSkillSuccessAction = createAction(
  '[Admin Skill Effect] Skill Successfully Deleted',
  props<{ id: string }>(),
);

export const AdminLoadSkillsUsageAction = createAction('[Admin Skill Effect] Load Skills Usage');

export const AdminSkillsUsageLoadedAction = createAction(
  '[Admin Skill Effect] Skills Usage Loaded',
  props<{ skillsUsage: SkillsUsage[] }>(),
);

export const AdminSkillsErroredAction = createAction(
  '[Admin Skill Effect] Skills Errored',
  props<{ error: AdminSkillApiError }>(),
);

export const AdminRemoveSkillsErrorAction = createAction(
  '[Admin Skill Effect] Remove Skills Error',
);

export const GoToSkillDefinitionAction = createAction(
  '[Admin Skill Effect] Go to Skill Definition',
);
